import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/admin-portal/components/AdminPortalScreen.tsx");
